import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { ToastConfig, ToastRef, ToastService } from '@gh/core-ui';
import { ToastContext } from './toast-context.service';
import { ToastPanelComponent } from './toast-panel.component';

@Injectable()
export class DefaultToastService extends ToastService {
  constructor(private overlay: Overlay,
              private context: ToastContext) {
    super();
    this.initPanel();
  }

  show(config: ToastConfig): ToastRef {
    return this.context.create(config);
  }

  closeAll(): void {
    this.context.closeAll();
  }

  hasUndoEligible(): boolean {
    return this.context.hasUndoEligible();
  }

  undoTop(): boolean {
    return this.context.undoTop();
  }

  private initPanel(): void {
    const overlay = this.createOverlay();
    overlay.attach(new ComponentPortal(ToastPanelComponent));
  }

  private createOverlay(): OverlayRef {
    const overlayConfig = new OverlayConfig();
    overlayConfig.hasBackdrop = false;
    overlayConfig.positionStrategy = this.overlay.position().global().right('24px').bottom('24px');
    overlayConfig.panelClass = 'toast-overlay-pane';
    return this.overlay.create(overlayConfig);
  }
}
